import { Image, Link, Page, TextBalancer } from 'components/common';
import { Card, CardBody } from 'components/common/v2';
import HeaderSEO from 'components/HeaderSEO';
import { useEffect, useRef } from 'react';

const YBExpressPage = () => {
  const linkRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (linkRef) {
      setTimeout(() => {
        linkRef.current?.click();
      }, 3 * 1000);
    }
  }, []);

  return (
    <Page
      header={
        <>
          <HeaderSEO
            title="Yummy Bros - The Most Enjoyable Healthy Meal Prep in Singapore!"
            description="With Yummy Bros highly-rated meal prep, you'll have high protein, customizable, & healthy food delivered straight to your doorstep! Order online today!"
            ogType="website"
            preventIndex
          />
        </>
      }
      content={
        <div className="tw-flex tw-justify-center tw-items-center tw-min-h-[32rem]">
          <Card className="tw-border-none">
            <CardBody>
              <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4">
                <TextBalancer className="tw-mb-0 tw-leading-tight tw-text-center">
                  You are being redirected to{' '}
                </TextBalancer>
                <Link
                  to="https://express.yummybros.com?utm_source=yummybros&utm_medium=referral"
                  ref={linkRef}
                  className="tw-m-0 tw-leading-none"
                >
                  <Image
                    src="/assets/images/ybexpress.gif"
                    alt="Yummy Bros Express"
                    width={320}
                    height={72}
                    className="object-cover object-center"
                  />
                </Link>
                <TextBalancer className="tw-mb-0 tw-leading-tight">
                  Please do not close or leave this page.
                </TextBalancer>
              </div>
            </CardBody>
          </Card>
        </div>
      }
    />
  );
};

export default YBExpressPage;
